"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateTaxes = void 0;
var taxes_1 = require("./taxes");
function calculateTaxes(input) {
    if (input.user.tax_info.region === "US") {
        if (input.incomes) {
            return (0, taxes_1.calculateUSATaxes)({ user: input.user, incomes: input.incomes });
        }
        else {
            return (0, taxes_1.calculateUSATaxes)({ user: input.user });
        }
    }
    else {
        if (input.incomes) {
            return (0, taxes_1.calculateUKTaxes)({ user: input.user, incomes: input.incomes });
        }
        else {
            return (0, taxes_1.calculateUKTaxes)({ user: input.user });
        }
    }
}
exports.calculateTaxes = calculateTaxes;
